import { AvatarProps, TextProps } from "@mantine/core";

export const isNumberLike = (value: unknown): value is number | string => {
    if (typeof value === "number") {
        return true;
    }

    if (typeof value === "string") {
        if (value.startsWith("calc(") || value.startsWith("var(") || (value.includes(" ") && value.trim() !== "")) {
            return true;
        }

        const cssUnitsRegex = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
        const values = value.trim().split(/\s+/);
        return values.every((val) => cssUnitsRegex.test(val));
    }

    return false;
};

export const avatarSizeMap: Record<"xs" | "sm" | "md" | "lg" | "xl", number> = {
    xs: 16,
    sm: 26,
    md: 38,
    lg: 56,
    xl: 84,
};

export const toAvatarSize = (sizeValue: AvatarProps["size"] | undefined, fallback: number): number | string => {
    const resolved = sizeValue ?? fallback;
    if (typeof resolved === "undefined") {
        return fallback;
    }

    if (isNumberLike(resolved)) {
        return resolved;
    }

    return avatarSizeMap[resolved as keyof typeof avatarSizeMap] ?? `var(--avatar-size-${resolved})`;
};

export const toTextSize = (sizeValue: TextProps["size"] | undefined): number | string => {
    const resolved = sizeValue ?? "sm";
    return isNumberLike(resolved) ? resolved : `var(--mantine-font-size-${resolved})`;
};